/* eslint-disable vue/order-in-components */
<template>
  <div>
    <v-app
      class="main-app"
      :class="[$route.params.fieldName, $route.name]">
      <UserInvitationModal />
      <LibraryEditingModal />
      <UserReinvitationModal />
      <UserGroupsModal />
      <!-- Sizes your content based upon application components -->
      <v-main :class="$route.name">
        <div
          v-if="$store.state.userInfo
            && !this.$store.state.loginRelatedPages.includes($route.name)"
          class="header-container">
          <v-row
            class="header-container__content flex-sm-nowrap"
            :class="'header-container__content--' + $route.name">
            <div class="header-container__content--nav">
              <router-link
                v-for="item in headerNavs"
                :key="item.path"
                :to="`/${item.path}`">
                {{ item.title }}
              </router-link>
            </div>
            <p class="d-flex align-center mb-0 ml-auto">
              <HeaderAccountMenu />
            </p>
          </v-row>
        </div>
        <router-view />
      </v-main>
      <v-row
        v-if="$store.state.showSpinner"
        justify="center"
        align="center"
        class="spinner-container">
        <v-progress-circular
          :size="50"
          color="lightBlue"
          indeterminate />
      </v-row>
      <SnackBar />
    </v-app>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AWS from '@/services/AwsSdk';
import HeaderAccountMenu from '@/components/headerAccountMenu/index.vue';
import SnackBar from '@/components/snackBar/index.vue';
import UserInvitationModal from '@/components/userInvitationModal/index.vue';
import UserReinvitationModal from '@/components/userReinvitationModal/index.vue';
import UserGroupsModal from '@/components/userGroupsModal/index.vue';
import LibraryEditingModal from '@/components/libraryEditingModal/index.vue';
export default {
  name: 'App',
  components: {
    HeaderAccountMenu,
    SnackBar,
    UserInvitationModal,
    LibraryEditingModal,
    UserGroupsModal,
    UserReinvitationModal,
  },
  data() {
    return {
      drawer: false,
      headerNavs: [
        {
          title: 'Users', path: 'users',
        },
        {
          title: 'Collections', path: 'collections',
        },
        {
          title: 'Workspaces', path: 'workspaces',
        },
        {
          title: 'Site Configuration', path: 'site-configuration',
        },
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    AWS.init();
  },
};
</script>
<style lang="scss"  src="./App.scss"></style>
